<div class="w-100 d-flex justify-content-between" style="margin-top: 9px">
  <div class="justify-content-start">
    <h6 class="quicksand-bold-label mb-0">Recommendation of the day</h6>
    <label class="quicksand-normal-label recommendation-subtext">
      This feature generates an idea for a group activity to teach a standard
      from your current class.
    </label>
  </div>
  <div
    [ngClass]="
      analyticsService?.currentTheme === 'material-dark'
        ? 'icon-background-dark'
        : 'icon-background-light'
    "
  >
    <span
      class="icon-close-classroom-modal d-block cursor-pointer"
      (click)="dialog.closeAll(); resetSubmitArea.emit(true)"
    >
      <nb-icon icon="close-outline" class="icon-close"></nb-icon>
    </span>
  </div>
</div>

<hr />

<div
  class="{{
    storageService.detectMob() ? 'd-block' : 'd-flex justify-content-between'
  }}"
>
  <div class="section-id-content">
    <label class="text-bold quicksand-bold-label"
      >Section Id: <br />
      <span *ngFor="let recommendation of recommendation_section; let i = index"
        >{{ i + 1 }}. {{ recommendation }}<br />
      </span>
    </label>
  </div>
  <div
    class="{{ storageService.detectMob() ? 'd-block' : 'd-flex align-items-center' }}"
  >
    <div
      *ngIf="classroom"
      class="get-recommendation text-capitalize text-center quicksand-bold-label align-items-baseline mr-3"
      style="cursor: pointer"
      (click)="
        router.navigateByUrl(
          '/test-quizzes/recommendations-list?subject_id=' +
            classroom?.current_subject_id +
            '&grades_id=' +
            classroom?.grades_id
        );
        dialog.closeAll()
      "
    >
      View Saved Recommendations
      <div>
        <hr class="hr-style-for-recommendation" />
      </div>
    </div>

    <div
      class="generate-pdf-button-content {{
        storageService.detectMob() ? 'mt-3' : ''
      }}"
    >
      <button
        nbButton
        class="generate-pdf get-recommendation text-capitalize quicksand-bold-label"
        (click)="makePdf()"
      >
        Generate PDF
      </button>
    </div>
  </div>
</div>

<div
  class="w-100 mt-3 recommendation-text quicksand-normal-label"
  #recommendationContent
  [mathjax]="recommendations
      ? recommendations?.recommendation
      : recommendations?.recommendation"
></div>
